import { BindingEngine, Disposable, ICollectionObserverSplice, autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class DemoEssCheckboxElementPage extends ComponentBase {
    protected id: guid = guid();
    protected groupData: IExampleData[] = [{ name: 'Item 1', value: 'A' }, { name: 'Item 2', value: 'B' }, { name: 'Item 3', value: 'C' }];

    protected ex4selectedItemsSubscription: Disposable | null = null;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(protected readonly bindingEngine: BindingEngine, ...rest: any[]) {
        super(...rest);
    }

    protected attached() {
        this.ex4selectedItemsSubscription = this.bindingEngine
            .collectionObserver(this.ex4selectedItems) // observe the selectedBarriers array, which changes in the multi-select Barrier Definition Select element
            .subscribe(this.ex4selectedItemsChanged.bind(this)); // pass the splice information (addedCount, index, removed) to selectedBarriersChanged method

    }

    protected detached(): void {
        if(this.ex4selectedItemsSubscription) this.ex4selectedItemsSubscription.dispose();
    }

    ////****************** Example 2 ********************************************////
    protected isRequired?: boolean = true;
    protected isChecked?: boolean = true;
    protected isDisabled?: boolean = true;
    protected isReadonly?: boolean = true;

    protected toggleIsRequired(value: boolean): void {
        this.isRequired = value;
    }

    protected toggleIsChecked(value: boolean): void {
        this.isChecked = value;
    }

    protected toggleIsDisabled(value: boolean): void {
        this.isDisabled = value;
    }

    protected toggleIsReadonly(value: boolean): void {
        this.isReadonly = value;
    }

    ////****************** Example 3 ********************************************////

    //Note: This example perfectly displays the flaw in our current design of ess-checkbox that have both a label and tooltip.
    //That flaw being: when an ess-checkbox has both tooltip and label, the screen reader will end up prioritizing the tooltip, which we do not want.
    //However, we do not have any existing examples of this instance. All uses of ess-checkbox have either labels OR tooltips.
    protected ex3Label: string | null = 'Example Label';
    protected ex3Tooltip: string | null = 'Example Tooltip';


    ////****************** Example 4 ********************************************////
    protected ex4selectedItems: IExampleData[] = [];
    protected ex4groupName: string | null = 'ex4Group';
    protected ex4selectedItemsPretty: string = '';
    protected ex4itemsAdded: IExampleData[] = [];
    protected ex4itemsRemoved: IExampleData[] = [];

    protected ex4selectedItemsChanged(splices: ICollectionObserverSplice<IExampleData>[]): void {
        for(let i = 0; i < splices.length; i++) {
            let splice = splices[i];
            this.ex4itemsAdded = this.ex4selectedItems.slice(splice.index, splice.index + splice.addedCount);
            this.ex4itemsRemoved = splice.removed;
        }
        this.ex4selectedItemsPretty = this.jsonPretty(this.ex4selectedItems);
    }

    protected jsonPretty(value: any): string {
        return JSON.stringify(value, null, 2);
    }

}

interface IExampleData {
    name: string;
    value: string;
}
